<!--
 * @Descripttion: 
 * @version: 
 * @Author: xzx
 * @Date: 2021-01-07 16:59:48
 * @LastEditors: xzx
 * @LastEditTime: 2021-01-14 10:49:07
-->
<template>
    <div :ref="setRef" style="position: absolute; width: 500px; height: 300px;"></div>
</template>

<script>
import * as echarts from 'echarts'
// import 'echarts/theme/tw_dark.js'
import twDark from '../../../public/tw_dark'
import { onMounted, reactive, watchEffect } from "vue";
import messageService from '../../services/message.service'

export default {
    name: "tw-ws-line",
    
    setup(props) {
        let myRef;

        const setRef = el => {
            myRef = el;
        }

        // 接口数据：http://api.jeecg.com/mock/26/bar
        let mockJson = reactive({"data":{"categories":["1月","2月","3月","4月","5月"],"series":[{"name":"销售趋势","data":[10087,34087,23087,54087,34087]}]}});

        const dataInit = function() {
            if(mockJson && mockJson.data && mockJson.data.series){
                mockJson.data.series.forEach(function(val){
                    val.type = 'line';
                    val.label = {
                        show: true, //开启显示
                        position: 'top', //在上方显示
                        textStyle: { //数值样式
                            color: 'rgba(113,237,255,1)',
                            fontSize: '16'
                        }
                    }
                })
            }
        }

        const echartInit = () =>{
            echarts.registerTheme('tw_dark', twDark)
            var myChart = echarts.init(myRef, 'tw_dark');
            // 指定图表的配置项和数据
            var option = {
                title: {
                    text: props.title
                },
                legend: {
                    show: props.legendShow
                },
                tooltip: {
                    show: true,
                    trigger: 'axis'
                },
                xAxis: {
                    data: mockJson.data.categories,
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        alignWithLabel: true
                    }
                },
                yAxis: {
                    splitLine: {
                        show: false
                    }
                },
                series: mockJson.data.series
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        }

        onMounted(()=>{
            watchEffect(() => {
                const data = props.data_source && props.data_source.datas

                if (data) {
                    if (data.data && data.data.categories && data.data.series) {
                        mockJson = reactive(props.data_source.datas)
                    } else {
                        if (Array.isArray(data) && props.caption_name && props.value_name) {
                            const chartData = { data: { categories: [], series:[{ name: props.series_name, data: [] }]}}
                            
                            data.forEach(el => {
                                chartData.data.categories.push(el[props.caption_name])
                                chartData.data.series[0].data.push(el[props.value_name])
                            })
                            mockJson = reactive(chartData)
                        } else {
                            messageService.error('折线图：请检查【数据源】数据格式');
                            mockJson = reactive({
                                data: {
                                    categories: [],
                                    series: []
                                }
                            })
                        }
                    }
                }
                dataInit()
                echartInit()
            })
        })

        return {
            setRef,
            echartInit
        };

    },

    props: {
        title: String,
        legendShow: {
            type: Boolean,
            default: true
        },
        series_name: {
            type: String,
            default: '',
        },
        data_source: {
            type: Object,
            default: function() {
                return { }
            }
        },
        caption_name: {
            type: String,
            default: ''
        },
        value_name: {
            type: String,
            default: ''
        }
    }
  }
</script>

<style>

</style>